/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import { LegalEntityVO } from '@well/common-libs/legal-entity-management/domain-model';

export class CompanyDetailsVO extends JSONable {
  legalEntityVO: LegalEntityVO | undefined = undefined;
  createServiceProvider: boolean | undefined = undefined;
  invoiceSeriesPrefix?: string;

  constructor(){
    super();
    this.legalEntityVO = new LegalEntityVO();
  }
}
